import React from "react";
import { checkEmptyObject, formatNumber } from "../../../services";
import styles from "./SearchResult.scss";
import { StaticHTML } from "../../../components";

const SearchResult = ({ ads, className, metaData, categoryName }) => {
  let countText = "";
  if (ads) {
    if (ads.count && String(ads.count).slice(-2) == "11") {
      countText = "oglasa";
    } else if (ads.count && String(ads.count).slice(-1) == "1") {
      countText = "oglas";
    } else {
      countText = "oglasa";
    }

  }


  // Build the title based on heading and other properties
  const buildTitle = () => {
    return checkEmptyObject(metaData) && metaData.h1
      ? `<h1 class="${styles.title}">${metaData.h1}</h1>
          <span> - ${ checkEmptyObject(ads) ? formatNumber(ads.count) : 0}</span>
          <span class="${styles.pale}">${countText}</span> 
        `
      : `<span class="${styles.count}"> ${
          categoryName ? `${categoryName} - ` : ""
        } ${checkEmptyObject(ads) ? formatNumber(ads.count) : 0}</span>
    <span class="${styles.pale}">${countText}</span>`;


  };


  return (
    <span className={className}>
      <StaticHTML content={buildTitle()} />
    </span>
  );
};

SearchResult.defaultProps = {
  className: "",
  ads: {}
};

export default SearchResult;



// WEBPACK FOOTER //
// ./src/containers/SearchPage/SearchResult/index.tsx